import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                'https://backend-alien.vercel.app/api/auth/forgotpassword',
                { email },
            );
            console.log(response.data);
            // Handle success response
            if(response.data.success){
              toast.success(response.data.message);
              navigate("/home");
            }
            else{
              toast.error("Error Resetting Password.")
            }
        } catch (error) {
            console.error('Error:', error.response.data);
            toast.error(error.response.data.message);
            // Handle error response
        }
    };

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="bg-white py-8 px-4 sm:px-6 lg:px-8 w-full max-w-md">
                <div>
                    <h2 className="text-center text-3xl font-extrabold text-gray-900">Forgot your password?</h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        Enter your email address and we'll send you a link to reset your password.
                    </p>
                </div>
                <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="email" className="sr-only">
                                Email address
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={handleChange}
                                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                placeholder="Email address"
                            />
                        </div>
                    </div>
                    <div>
                        <button
                            type="submit"
                            className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            Send reset link
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
